/** @type {{streetAddress: string; city: string; state: string; postalCode: number}[]} */
export default [
	{
		city: 'Riverton',
		postalCode: 10001,
		state: 'IL',
		streetAddress: '7826 Maple St',
	},
	{
		city: 'Shelbyville',
		postalCode: 65801,
		state: 'CA',
		streetAddress: '3899 Main St',
	},
	{
		city: 'Shelbyville',
		postalCode: 33101,
		state: 'PA',
		streetAddress: '7689 Elm Rd',
	},
	{
		city: 'Riverton',
		postalCode: 19101,
		state: 'OH',
		streetAddress: '4169 Maple St',
	},
	{
		city: 'Riverton',
		postalCode: 2185,
		state: 'MO',
		streetAddress: '8627 Main St',
	},
	{
		city: 'Boston',
		postalCode: 43201,
		state: 'NY',
		streetAddress: '181 Main St',
	},
	{
		city: 'San Jose',
		postalCode: 62701,
		state: 'MO',
		streetAddress: '7759 Maple St',
	},
	{
		city: 'San Jose',
		postalCode: 33101,
		state: 'OH',
		streetAddress: '5199 Oak St',
	},
	{
		city: 'Brockton',
		postalCode: 90210,
		state: 'OH',
		streetAddress: '722 Pine Dr',
	},
	{
		city: 'Quincy',
		postalCode: 90210,
		state: 'MA',
		streetAddress: '3621 Maple St',
	},
	{
		city: 'Brockton',
		postalCode: 77001,
		state: 'CA',
		streetAddress: '552 Main St',
	},
	{
		city: 'Springfield',
		postalCode: 19101,
		state: 'PA',
		streetAddress: '4865 Oak St',
	},
	{
		city: 'Quincy',
		postalCode: 33101,
		state: 'PA',
		streetAddress: '2988 Pine Dr',
	},
	{
		city: 'Quincy',
		postalCode: 90210,
		state: 'IL',
		streetAddress: '8004 Oak St',
	},
	{
		city: 'Boston',
		postalCode: 10001,
		state: 'FL',
		streetAddress: '6742 Oak St',
	},
	{
		city: 'Worcester',
		postalCode: 43201,
		state: 'PA',
		streetAddress: '730 Pine Dr',
	},
	{
		city: 'Brockton',
		postalCode: 19101,
		state: 'PA',
		streetAddress: '5552 Pine Dr',
	},
	{
		city: 'San Jose',
		postalCode: 65801,
		state: 'MA',
		streetAddress: '207 Oak St',
	},
	{
		city: 'Quincy',
		postalCode: 65801,
		state: 'PA',
		streetAddress: '9869 Oak St',
	},
	{
		city: 'Riverton',
		postalCode: 48101,
		state: 'MO',
		streetAddress: '5122 Elm Rd',
	},
	{
		city: 'Worcester',
		postalCode: 77001,
		state: 'PA',
		streetAddress: '9168 Maple St',
	},
	{
		city: 'Riverton',
		postalCode: 2185,
		state: 'MI',
		streetAddress: '8108 Main St',
	},
	{
		city: 'Brockton',
		postalCode: 43201,
		state: 'MO',
		streetAddress: '9750 Elm Rd',
	},
	{
		city: 'North Haverbrook',
		postalCode: 62701,
		state: 'MA',
		streetAddress: '6311 Maple St',
	},
	{
		city: 'Boston',
		postalCode: 62701,
		state: 'TX',
		streetAddress: '5931 Maple St',
	},
];
